import type { RefObject } from 'react';
import { select } from 'd3-selection';
import type { DragBehavior, D3DragEvent } from 'd3-drag';
import { drag as Drag } from 'd3-drag';
import { MouseEventButton } from '../basic/MouseEventButton';

export class HandleD3Drag {
  constructor(
    private readonly ref: RefObject<Element | null>,
    private readonly checkDraggingMultiSelectionDisabled: (e: MouseEvent) => boolean
  ) {}

  onMounted(
    onDrag: (event: D3DragEvent<Element, unknown, unknown>) => void,
    onDragStart?: (event: D3DragEvent<Element, unknown, unknown>) => void,
    onDragEnd?: (event: D3DragEvent<Element, unknown, unknown>) => void
  ): void {
    const drag: DragBehavior<Element, unknown, unknown> = Drag();

    drag.on('drag', (event: D3DragEvent<Element, unknown, unknown>) => {
      onDrag(event);
    });

    if (onDragStart) {
      drag
        .on('start', (event: D3DragEvent<Element, unknown, unknown>) => {
          onDragStart(event);
        })
        .filter((event: MouseEvent) => {
          if (event.buttons === MouseEventButton.SecondaryButton) {
            // 右クリックによるドラッグは許可しない
            return false;
          }

          if (this.checkDraggingMultiSelectionDisabled(event)) {
            return false;
          }

          return true;
        });
    }

    if (onDragEnd) {
      drag.on('end', (event: D3DragEvent<Element, unknown, unknown>) => {
        onDragEnd(event);
      });
    }

    this.ref.current && select(this.ref.current).call(drag);
  }

  onWillUnmounted(): void {
    select(this.ref.current).on('.drag', null);
  }
}
